<!--suppress ALL -->
<template>
  <div>
    <div class="" v-if="isItDevEnv">
      isGuidNull = {{isGuidNull}}<br>
      guid = {{guid}}<br>
      isDemandeInitialeROLoaded = {{isDemandeInitialeROLoaded}}<br>
      step1IsDone = {{step1IsDone}}<br>
      isIdDemandeValid = {{isIdDemandeValid}}<br>
      isGuidValid = {{isGuidValid}}<br>
      streetSelected = {{streetSelected}}<br>
      geometrieWKT = {{demandeDataEnCours.geometrieChantiersSaisie}}
    </div>
    <p v-if="!isDemandeInitialeROLoaded && !isGuidNull">Veuillez patienter, récupération de la demande numéro : {{guid}}</p>
    <div v-if="!isGuidValid && !isGuidNull" class="alert alert-danger" role="alert"><p>{{demandeDataEnCours.realGuid}}</p></div>
    <div v-if="isSavingError" class="alert alert-danger" role="alert">
      <p>{{lastSavingError}}</p>
    </div>
    <p v-if="isDemandeInitialeROLoaded">guid effectif : [{{demandeDataEnCours.realGuid}}] créé le : {{demandeInitialeRO.datecreated}}</p>
    <!--
    <p v-if="isItDevEnv">{{data_json}}</p>
    -->
    <go-collapse :title="step1Msg" :open="!step1IsDone && isGuidValid" :done="step1IsDone" :disabled="!isGuidValid" v-show="isGuidValid">
      <form id="goform-step1" action="#">
        <div class="form-group col-md-6">
          <label for="idaff">identifiant reçu par email: </label>
          <input type="number" id="idaff" class="form-control"
                 min="1" max="9999999" maxlength="7" tabindex="1"
                 v-model="idDemande" disabled/>
          <!-- TODO if isGuidNull add change handling event to query db with axios-->
        </div>
        <div class="form-group col-md-6">
          <label for="listStreets" class="">choisissez la rue en relation avec cette demande: </label>
          <!--    http://sagalbot.github.io/vue-select/-->
          <v-select id="listStreets" tabindex="2" v-model="streetSelected"
                    :options="streetList"
                    :on-change="newStreetSelected"
                    placeholder="Veuillez choisir une rue ..."
                    label="label">
          </v-select>
          <p>{{streetSelected}}</p>
        </div>
        <div class="form-group col-md-6">
         <p>
        En cas de problème, n'hésitez pas à nous contacter.<br/>
        Nous répondons à vos appels du lundi au vendredi, de 08h00 à 11h30 et de 14h00 à 16h00.<br/><br/>
        <strong>Service de la mobilité et de l’aménagement des espaces publics</strong><br/>
        Surveillance du domaine public<br/><br/>
        Téléphones  <a href="tel:+41213155412">+41 21 315  5412</a> ou  <a href="tel:+41213155262">5262</a><br/>
        E-mail <a href="mailto:podp@lausanne.ch">podp@lausanne.ch</a><br/>
      </p>
        </div>
      </form>
    </go-collapse>

    <div id="questions" v-show="isIdDemandeValid && !isSubmitToLocalDatabaseSuccessfull">
      <!-- DEBUT SECTION 2 : informations générales -->
      <go-collapse :title="step2Msg" :open="step1IsDone && !demandeDataEnCours.step2IsDone" :disabled="!isIdDemandeValid"
                   :done="demandeDataEnCours.step2IsDone">
          <div class="form-group col-md-6">
            <h4>{{demandeInitialeRO.id}}/{{streetName}}</h4>
            <h4>{{demandeInitialeRO.nomAffaire}}</h4>
            <p>
              L'inspecteur des chantiers de la Ville en charge de l'affaire est :
              <strong>M.{{demandeInitialeRO.responsableVdL}}</strong>
            </p>
            <h5 v-if="demandeInitialeRO.itWasUnAuthorizedOccupacy">
              <strong>il s'agit d'une demande effectuée suite à une occupation non autorisée</strong>
            </h5>
            <h5 v-if="demandeInitialeRO.BPayant">Ce permis sera <strong>payant</strong></h5>
            <h5 v-else>Ce permis sera gratuit</h5>
            <div v-if="isDemandeInitialeROLoaded">
              <go-collapse-acteur-role-details :acteurReference="demandeInitialeRO.Mandataire">
              </go-collapse-acteur-role-details>
              <go-collapse-acteur-role-details :acteurReference="demandeInitialeRO.Beneficiaire">
              </go-collapse-acteur-role-details>
              <go-collapse-acteur-role-details :acteurReference="demandeInitialeRO.MaitreOuvrage">
                Affaire Coordination : {{demandeInitialeRO.IdAffCoordChantier}} / {{demandeInitialeRO.nomAffCoordChantier}}
              </go-collapse-acteur-role-details>
            </div>
          </div>
          <div class="form-group col-md-6">
            <fieldset><legend>Vos informations de contact </legend>
              <h5>le permis d'occupation temporaire du domaine public sera envoyé à <strong>{{demandeDataEnCours.affClientEmail}}</strong></h5>
              <!-- selon séance avec S.Michaud 16 Nov 2018 ces champs ne doivent pas être modifiables par demandeur
              <div class="form-group">
                <label for="affClientEmail">Votre email :</label>
                <input type="email" v-model="demandeDataEnCours.affClientEmail" class="form-control" id="affClientEmail" placeholder="Email">
                <span id="helpBlockaffClientEmail" class="help-block "><strong>ATTENTION, le permis d'occupation temporaire du domaine public sera envoyé à cette adresse</strong></span>
              </div>
              -->
              <div class="form-group">
                <label for="affClientContact">Prénom Nom:</label>
                <input type="text" v-model="demandeDataEnCours.affClientContact" class="form-control" id="affClientContact" placeholder="Email">
              </div>
              <div class="form-group">
                <label for="affClientTelephone">Numéro de téléphone :</label>
                <input type="tel" v-model="demandeDataEnCours.affClientTelephone" class="form-control" id="affClientTelephone" placeholder="Téléphone">
              </div>
            </fieldset>

            <!-- selon demande M. DESMET 19 juin 2023 enlever section Police
            <label for="responsablePolice">Avez-vous déjà pris contact avec la police ?</label>
            <go-switch v-model="demandeDataEnCours.IsContactPoliceDone"></go-switch>
            -->
            <template v-if="demandeDataEnCours.IsContactPoliceDone">
              <!--
              <v-select id="responsablePolice" tabindex="2" v-model="demandeDataEnCours.responsablePolice"
                        :options="step2arrContactPolice"
                        placeholder="Veuillez SVP indiquer le nom de votre contact à la Police">
              </v-select>
              -->
<!--              <template v-if="demandeDataEnCours.responsablePolice !== null">-->
                <div class="col-sm-12 cg-button-next" >
                  <el-button type="primary" class="pull-right"
                             v-on:click="saveForm($event);demandeDataEnCours.step2IsDone=true;"
                             :disabled="!isStep2Valid">
                    SUIVANT<i class="el-icon-arrow-right el-icon-right"></i>
                  </el-button>
                </div>
<!--              </template>-->
            </template>
          </div>
      </go-collapse>
<!-- en mai 2018 il est décidé avec Séance Juriste  RM que seul 2 rôles sont possibles et qu'ils sont saisis dans Goéland
      <go-collapse :title="step3Msg" :open="demandeDataEnCours.step2IsDone && !demandeDataEnCours.step3IsDone"
                   :disabled="!isStep2Valid" :done="demandeDataEnCours.step3IsDone">
        <go-select-acteur id="acteurBeneficiaire" v-model="demandeDataEnCours.acteurBeneficiaire"
                          v-on:saverequest="saveForm"
                          acteurTitle="Bénéficiaire du permis"
                          v-if="!demandeInitialeRO.isBeneficiaireGiven"
        />
        <p v-if="demandeDataEnCours.acteurBeneficiaire && isItDevEnv && !demandeInitialeRO.isBeneficiaireGiven">
          Outside goSelect Acteur choosen is :{{demandeDataEnCours.acteurBeneficiaire}}
        </p>
        <div v-if="demandeInitialeRO.isBeneficiaireGiven">
          <go-collapse-acteur-role-details :acteurReference="demandeInitialeRO.Beneficiaire">
          </go-collapse-acteur-role-details>
        </div>

        <go-select-acteur id="acteurMaitreOuvrage" v-model="demandeDataEnCours.acteurMaitreOuvrage"
                          v-on:saverequest="saveForm"
                          acteurTitle="Maitre d'ouvrage"
                          v-if="!demandeInitialeRO.isMaitreOuvrageGiven"
        />
        <p v-if="demandeDataEnCours.acteurMaitreOuvrage  && isItDevEnv && !demandeInitialeRO.isMaitreOuvrageGiven">
          Outside goSelect Acteur choosen is :{{demandeDataEnCours.acteurMaitreOuvrage}}
        </p>
        <div v-if="demandeInitialeRO.isMaitreOuvrageGiven">
          <go-collapse-acteur-role-details :acteurReference="demandeInitialeRO.MaitreOuvrage">
          </go-collapse-acteur-role-details>
        </div>

        <go-select-acteur id="acteurMandataire" v-model="demandeDataEnCours.acteurMandataire"
                          v-on:saverequest="saveForm"
                          acteurTitle="Mandataire"
                          v-if="!demandeInitialeRO.isMandataireGiven"
        />
        <p v-if="demandeDataEnCours.acteurMandataire  && isItDevEnv && !demandeInitialeRO.isMandataireGiven">
          Outside goSelect Acteur choosen is :{{demandeDataEnCours.acteurMandataire}}
        </p>
        <div v-if="demandeInitialeRO.isMandataireGiven">
          <go-collapse-acteur-role-details :acteurReference="demandeInitialeRO.Mandataire">
          </go-collapse-acteur-role-details>
        </div>

        <div v-if="demandeInitialeRO.BPayant">
          <div class="form-group">
            <label for="selectActeurFacturation">Selectionnez le destinataire de la facture</label>
            <v-select id="selectActeurFacturation" tabindex="2" v-model="demandeDataEnCours.acteurFacturationOptionSelected"
                      :options="step3arrActeurFacturationOptions"
                      placeholder="Veuillez choisir a qui doit être adressée la facture">
            </v-select>
          </div>

          <go-select-acteur id="acteurFacturation"
            v-if="demandeDataEnCours.acteurFacturationOptionSelected=='Autre'"
            v-model="demandeDataEnCours.acteurFacturation"
            v-on:saverequest="saveForm"
            acteurTitle="Facturation"/>
          <p v-if="demandeDataEnCours.acteurFacturation">
            Outside goSelect Acteur choosen is :{{demandeDataEnCours.acteurFacturation}}
          </p>
        </div>
      </go-collapse>
-->

      <div v-show="demandeDataEnCours.IsContactPoliceDone && demandeDataEnCours.step2IsDone">
        <!-- DEBUT SECTION 3 : LOCALISATION -->
        <go-collapse :title="step4Msg"
                    :open=" demandeDataEnCours.step2IsDone && !demandeDataEnCours.step4IsDone"
                     @gocollapseOpen="adjustMap"
                     :disabled="!isStep3Valid" :done="demandeDataEnCours.step4IsDone">
          <form id="goform-step4" action="#">
            <div class="form-group col-md-12">
              <p v-if="isPolygonAlreadyPresentInGoeland">Le périmètre des travaux a déjà été saisi par un service communal, il ne peut pas être modifié.</p>
              <p v-if="!isPolygonAlreadyPresentInGoeland">Veuillez dessiner ci-dessous le-s périmètre-s que vous souhaitez occuper.</p>
              <div v-if="showMap">
              <cgil-ol-map style="height: 800px; width: 100%" ref="mapchantier"
                           :edit-geom-enabled="!isPolygonAlreadyPresentInGoeland"
                           :center="center"
                           :zoom="8"
                           :layers-config="mapLayers"
                           :geomGeoJSON="demandeInitialeRO.geomAffCoordChantier"
                           :geomWkt="geometrieChantiersSaisiePrecedement"
                           @gomapSaveGeomClick="saveGeometry"
              ></cgil-ol-map>
              </div>
            </div>
          <div id="divcommentaireLocalisation"class="form-group col-md-6">
            <div class="">
              <label for="commentaireLocalisation" class="control-label">Remarque : </label>
            </div>
            <div class="">
              <textarea rows="3" id="commentaireLocalisation" v-model="demandeDataEnCours.commentaireLocalisation" type="text" class="form-control"/>
            </div>
          </div>
          <div id="divdescriptionTravaux"class="form-group col-md-6">
            <div class="">
              <label for="descriptionTravaux" class="control-label">* Description des travaux: </label>
            </div>
            <div class="">
              <textarea rows="3" id="descriptionTravaux"
                        placeholder="Veuillez SVP saisir la description des travaux prévus"
                        v-model="demandeDataEnCours.descriptionTravaux"
                        type="text"
                        class="form-control"/>
            </div>
          </div>
            <div id="divDatBegin" class="col-sm-6">
              <div class="form-group">
                <label for="dateDebutOccupation" class="control-label">
                  * Date de début :
                </label>
                <datepicker  id="dateDebutOccupation" v-model="demandeDataEnCours.dateDebutOccupation"
                            language="fr" :full-month-name="true" :bootstrapStyling="true" :mondayFirst="true"
                             v-on:selected="dateDebutUpdate" :disabled="dateDebutDisabled" :highlighted="datePickerHighlighted"></datepicker>
              </div>
            </div>
            <div id="divDateEnd" class="col-sm-6">
              <div class="form-group">
                <label for="dateFinOccupation" class="control-label">
                  * Date de fin :
                </label>
                <datepicker id="dateFinOccupation" v-model="demandeDataEnCours.dateFinOccupation"
                language="fr" :full-month-name="true" :bootstrapStyling="true" :mondayFirst="true"
                            v-on:selected="dateFinUpdate" :disabled="dateFinDisabled" :highlighted="datePickerHighlighted"></datepicker>
              </div>
            </div>
            <div class="col-sm-12" >
              <el-alert :closable="false" type="step4ValidationType" :title="step4ValidationText"></el-alert>
             <el-button type="primary" class="pull-right"
                        v-on:click="saveForm($event);demandeDataEnCours.step4IsDone=true;"
                        :disabled="!isStep4Valid">
               SUIVANT<i class="el-icon-arrow-right el-icon-right"></i>
             </el-button>
            </div>
          </form>
        </go-collapse>
        <!-- FIN  SECTION 3 : LOCALISATION -->
        <!-- DEBUT SECTION 4 : FOUILLES -->
        <go-collapse :title="step5Msg" :open="demandeDataEnCours.step4IsDone && !demandeDataEnCours.step5IsDone"
                     :disabled="!isStep4Valid" :done="demandeDataEnCours.step5IsDone">
          <div class="row">
            <div class="col-sm-12">
              <label for="isFouilleOuForage">Souhaitez-vous effectuer des travaux de fouilles et/ou de forages sur le domaine public ?</label>
              <go-switch id="isFouilleOuForage" class="pull-right" v-model="demandeDataEnCours.isFouilleOuForage"></go-switch>
            </div>
          </div>
          <hr>
          <div class="row" v-if="demandeDataEnCours.isFouilleOuForage">
            <div class="col-sm-12">
            <fieldset class="fouille-fieldset"><legend class="fouille-legend">Fouille numéro 1 :</legend>
              <div class="row">
                <div class="col-sm-4">
                  <input type="number" min=0 id="fouilleLongueur01" placeholder="Longueur en m"
                     v-model="demandeDataEnCours.fouilleLongueur01">
                </div>
                <div class="col-sm-4">
                  <input type="number" min=0 id="fouilleLargeur01" placeholder="Largeur en m"
                     v-model="demandeDataEnCours.fouilleLargeur01">
                </div>
                <div class="col-sm-4">Surface = <span class="pull-right">{{ calculSurface01 }}</span></div>
              </div>
            </fieldset>
            </div>
            <div class="col-sm-12">
              <fieldset class="fouille-fieldset"><legend class="fouille-legend">Fouille numéro 2 :</legend>
                <div class="row">
                  <div class="col-sm-4">
                    <input type="number" min=0 id="fouilleLongueur02" placeholder="Longueur en m"
                           v-model="demandeDataEnCours.fouilleLongueur02">
                  </div>
                  <div class="col-sm-4">
                    <input type="number" min=0 id="fouilleLargeur02" placeholder="Largeur en m"
                           v-model="demandeDataEnCours.fouilleLargeur02">
                  </div>
                  <div class="col-sm-4">Surface = <span class="pull-right">{{ calculSurface02 }}</span></div>
                </div>
              </fieldset>
            </div>
            <div class="col-sm-12">
              <fieldset class="fouille-fieldset"><legend class="fouille-legend">Fouille numéro 3 :</legend>
                <div class="row">
                  <div class="col-sm-4">
                    <input type="number" min=0 id="fouilleLongueur03" placeholder="Longueur en m"
                           v-model="demandeDataEnCours.fouilleLongueur03">
                  </div>
                  <div class="col-sm-4">
                    <input type="number" min=0 id="fouilleLargeur03" placeholder="Largeur en m"
                           v-model="demandeDataEnCours.fouilleLargeur03">
                  </div>
                  <div class="col-sm-4">Surface = <span class="pull-right">{{ calculSurface03 }}</span></div>
                </div>
              </fieldset>
            </div>
            <div class="col-sm-12">
              <fieldset class="fouille-fieldset"><legend class="fouille-legend">Fouille numéro 4 :</legend>
                <div class="row">
                  <div class="col-sm-4">
                    <input type="number" min=0 id="fouilleLongueur04" placeholder="Longueur en m"
                           v-model="demandeDataEnCours.fouilleLongueur04">
                  </div>
                  <div class="col-sm-4">
                    <input type="number" min=0 id="fouilleLargeur04" placeholder="Largeur en m"
                           v-model="demandeDataEnCours.fouilleLargeur04">
                  </div>
                  <div class="col-sm-4">Surface = <span class="pull-right">{{ calculSurface04 }}</span></div>
                </div>
              </fieldset>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <h4 class="pull-right">Surface Totale = &nbsp;<span class="pull-right">{{ calculSurfaceTotal }}</span></h4>
              </div>
            </div>
            <div class="col-sm-12">
              <div id="divDatBegin" class="col-sm-6">
                <div class="form-group">
                  <label for="fouilleDateDebut" class="control-label">
                    * Date de début :
                  </label>
                  <datepicker  id="fouilleDateDebut" v-model="demandeDataEnCours.fouilleDateDebut"
                               language="fr" :full-month-name="true" :bootstrapStyling="true" :mondayFirst="true"
                               v-on:selected="dateDebutUpdateFouille" :disabled="dateDebutDisabled_fouille" :highlighted="datePickerHighlighted_fouille"></datepicker>
                </div>
              </div>
              <div id="divDateEnd" class="col-sm-6">
                <div class="form-group">
                  <label for="fouilleDateFin" class="control-label">
                    * Date de fin :
                  </label>
                  <datepicker id="fouilleDateFin" v-model="demandeDataEnCours.fouilleDateFin"
                              language="fr" :full-month-name="true" :bootstrapStyling="true" :mondayFirst="true"
                              v-on:selected="dateFinUpdateFouille" :disabled="dateFinDisabled_fouille" :highlighted="datePickerHighlighted_fouille"></datepicker>
                </div>
              </div>
            </div>

            <div class="col-sm-12">
              <label for="isFouilleSurChaussee">Ces travaux se situent-ils sur la chaussée ?</label>
              <go-switch id="isFouilleSurChaussee" class="pull-right" v-model="demandeDataEnCours.isFouilleSurChaussee"></go-switch>
            </div>
            <div class="col-sm-12">
              <label for="isFouilleSurTrotoir">Ces travaux se situent-ils sur un trottoir ?</label>
              <go-switch id="isFouilleSurTrotoir" class="pull-right" v-model="demandeDataEnCours.isFouilleSurTrotoir"></go-switch>
            </div>
            <div class="col-sm-12">
              <label for="isFouilleEndomageBalisageSol">Ces travaux endommageront-ils le balisage au sol ?</label>
              <go-switch id="isFouilleEndomageBalisageSol" class="pull-right" v-model="demandeDataEnCours.isFouilleEndomageBalisageSol"></go-switch>
            </div>
            <div class="col-sm-12">
              <label for="isFouilleSurZonePavee">Ces travaux se situent-ils sur une zone pavée ?</label>
              <go-switch id="isFouilleSurZonePavee" class="pull-right" v-model="demandeDataEnCours.isFouilleSurZonePavee"></go-switch>
            </div>
            <div class="col-sm-12" v-if="demandeDataEnCours.isFouilleSurZonePavee">
              <el-card class="box-card">
              <div class="text-item">
                L’unité travaux peut réaliser les travaux de réfection de la zone pavée,
                devis sur demande auprès de
                <a href="mailto:mapunitetravaux@lausanne.ch">mapunitetravaux@lausanne.ch</a>.
                Le permis d’occupation et sa facturation seront adaptés en conséquence.
              </div>
              </el-card>
<!-- DEBUT section retiree selon demande M. DESMET juin 2023
              <label for="isFouilleSurZonePaveeDevisDemande">
                Souhaitez-vous nous confier la réfection du pavage, selon les tarifs en vigueur ci-dessous?
              </label>
              <go-switch id="isFouilleSurZonePaveeDevisDemande" class="pull-right" v-model="demandeDataEnCours.isFouilleSurZonePaveeDevisDemande"></go-switch>
              <el-card class="box-card">
                <div slot="header" class="clearfix">
                  <span><h4>Tarifs en vigueur (décembre 2018)</h4></span>
                </div>
                <div class="text item">
                  <p>Prix : CHF 300.- au m2 (hors taxe), comprenant :</p>
                  <ul>
                    <li>dégrapage et évacuation du revêtement provisoire</li>
                    <li>fourniture et mise en place de toutes les marchandises nécessaires</li>
                    <li>main-d'œuvre, machines et transports</li>
                  </ul>
                  <p>Cette prestation sera facturée en supplément du permis d'utilisation temporaire du domaine public.<br>
                    Pour plus de détails sur cette prestation, contactez
                    l'unité travaux du service des routes et de la mobilité<br></p>
                    <ul>
                      <li>Par téléphone :<a href="tel:+41213155491">+41 21 315 54 91</a></li>
                      <li>Par email : <a href="mailto:rmunitetravaux@lausanne.ch">rmunitetravaux@lausanne.ch</a></li>
                    </ul>
                </div>
              </el-card>
FIN section retiree selon demande M. DESMET juin 2023
-->
            </div>

          </div>
          <div class="col-sm-12" >
              <el-alert :closable="false" type="step5ValidationType" :title="step5ValidationText"></el-alert>
             <el-button type="primary" class="pull-right"
                        v-on:click="saveForm($event);demandeDataEnCours.step5IsDone=true;"
                        :disabled="!isStep5Valid">
               SUIVANT<i class="el-icon-arrow-right el-icon-right"></i>
             </el-button>
          </div>
        </go-collapse>
        <!-- FIN  SECTION 4 : FOUILLES -->
        <!-- DEBUT SECTION 5 : OCCUPATION -->
        <go-collapse :title="step6Msg" :open="demandeDataEnCours.step5IsDone && !demandeDataEnCours.step6IsDone"
                     :disabled="!isStep4Valid" :done="demandeDataEnCours.step6IsDone">
          <label for="isOccupationDP">Hormis les éventuelles fouilles et/ou forages, souhaitez-vous occuper le domaine public ?</label>
          <go-switch id="isOccupationDP" class="pull-right" v-model="demandeDataEnCours.isOccupationDP"></go-switch>
          <hr>
          <div class="row" v-if="demandeDataEnCours.isOccupationDP">
            <div class="form-group">
            <div class="col-sm-12">
              <fieldset class="fouille-fieldset"><legend class="fouille-legend">Taille occupation :</legend>
                <div class="row">
                  <div class="col-sm-4">
                    <input type="number" min=0 id="occupationDPLongueur01" placeholder="Longueur en m"
                           v-model="demandeDataEnCours.occupationDPLongueur01">
                  </div>
                  <div class="col-sm-4">
                    <input type="number" min=0 id="occupationDPLargeur01" placeholder="Largeur en m"
                           v-model="demandeDataEnCours.occupationDPLargeur01">
                  </div>
                  <div class="col-sm-4">Surface = <span class="pull-right">{{ calculSurfaceOccupationDP01 }}</span></div>
                </div>
              </fieldset>
            </div>
            </div>
            <div class="form-group">
              <div class="col-sm-12">
                <label>Veuillez cocher le-s type-s d'occupation souhaité-s</label>
              </div>
            </div>
            <div class="form-group">
              <div class="col-sm-4">
                <div class="checkbox goOccupationCheckbox">
                  <label>
                    <input type="checkbox" v-model="demandeDataEnCours.isOccupation_Benne"> Benne
                  </label>
                </div>
              </div>
              <div class="col-sm-4">
                <div class="checkbox goOccupationCheckbox">
                  <label>
                    <input type="checkbox" v-model="demandeDataEnCours.isOccupation_DepotMateriel"> Dépôt de matériel
                  </label>
                </div>
              </div>
              <div class="col-sm-4">
                <div class="checkbox goOccupationCheckbox">
                  <label>
                    <input type="checkbox" v-model="demandeDataEnCours.isOccupation_DepotEnginsChantier"> Dépôt d'engins de chantier
                  </label>
                </div>
              </div>
              <div class="col-sm-4">
                <div class="checkbox goOccupationCheckbox">
                  <label>
                    <input type="checkbox" v-model="demandeDataEnCours.isOccupation_PalissadeOuClotureChantier">  Palissade / Clôture de chantier
                  </label>
                </div>
              </div>
              <div class="col-sm-4">
                <div class="checkbox goOccupationCheckbox">
                  <label>
                    <input type="checkbox" v-model="demandeDataEnCours.isOccupation_RoulotteOuContainer"> Roulotte / Container de chantier
                  </label>
                </div>
              </div>
              <div class="col-sm-4">
                <div class="checkbox goOccupationCheckbox">
                  <label>
                    <input type="checkbox" v-model="demandeDataEnCours.isOccupation_CamionNacelle"> Camion nacelle
                  </label>
                </div>
              </div>
              <div class="col-sm-4">
                <div class="checkbox goOccupationCheckbox">
                  <label>
                    <input type="checkbox" v-model="demandeDataEnCours.isOccupation_CamionGrue">  Camion grue
                  </label>
                </div>
              </div>
              <div class="col-sm-4">
                <div class="checkbox goOccupationCheckbox">
                  <label>
                    <input type="checkbox" v-model="demandeDataEnCours.isOccupation_Grue"> Grue
                  </label>
                </div>
              </div>
              <div class="col-sm-4">
                <div class="checkbox goOccupationCheckbox">
                  <label>
                    <input type="checkbox" v-model="demandeDataEnCours.isOccupation_ChauffageMobile"> Chauffage mobile
                  </label>
                </div>
              </div>
              <div class="col-sm-4">
                <div class="checkbox goOccupationCheckbox">
                  <label>
                    <input type="checkbox" v-model="demandeDataEnCours.isOccupation_Echafaudage">  Echafaudage
                  </label>
                </div>
              </div>
              <div class="col-sm-4">
                <div class="checkbox goOccupationCheckbox">
                  <label>
                    <input type="checkbox" v-model="demandeDataEnCours.isOccupation_ElagageArbre"> Elagage d'arbre
                  </label>
                </div>
              </div>
              <div class="col-sm-4">
                <div class="checkbox goOccupationCheckbox">
                  <label>
                    <input type="checkbox" v-model="demandeDataEnCours.isOccupation_Etayage"> Etayage
                  </label>
                </div>
              </div>
              <div class="col-sm-4">
                <div class="checkbox goOccupationCheckbox">
                  <label>
                    <input type="checkbox" v-model="demandeDataEnCours.isOccupation_PontRoulant">  Pont roulant
                  </label>
                </div>
              </div>
              <div class="col-sm-4">
                <div class="checkbox goOccupationCheckbox">
                  <label>
                    <input type="checkbox" v-model="demandeDataEnCours.isOccupation_AccesChantier"> Accès chantier
                  </label>
                </div>
              </div>
              <div class="col-sm-4">
                <div class="checkbox goOccupationCheckbox">
                  <label>
                    <input type="checkbox" v-model="demandeDataEnCours.isOccupation_GroupeElectrogene"> Groupe électrogène
                  </label>
                </div>
              </div>
              <div class="col-sm-4">
                <div class="checkbox goOccupationCheckbox">
                  <label>
                    <input type="checkbox" v-model="demandeDataEnCours.isOccupation_PoseDeposeModificationEnseigne">
                    Pose / dépose / modification d’enseigne ou de support d’affichage
                  </label>
                </div>
              </div>
              <div class="col-sm-8">

                  <label for="Occupation_Autre" style="font-weight: normal" class="goOccupationCheckbox">Autre : </label>
                  <input type="text" class="form-control" id="Occupation_Autre"
                         style="display: inline-block; width: 75%"
                         placeholder="indiquez le type d'occupation"
                         v-model="demandeDataEnCours.Occupation_Autre">
              </div>
            </div>
          </div>
          <div class="col-sm-12" >
              <el-alert :closable="false" type="step6ValidationType" :title="step6ValidationText"></el-alert>
             <el-button type="primary" class="pull-right"
                        v-on:click="saveForm($event);demandeDataEnCours.step6IsDone=true;"
                        :disabled="!isStep6Valid">
               SUIVANT<i class="el-icon-arrow-right el-icon-right"></i>
             </el-button>
          </div>
        </go-collapse>
        <!-- FIN  SECTION 5 : OCCUPATION -->
        <!-- DEBUT SECTION 6 : PLACES DE STATIONNEMENT -->
        <go-collapse :title="step7Msg" :open="demandeDataEnCours.step6IsDone && !demandeDataEnCours.step7IsDone"
                     :disabled="!isStep6Valid" :done="demandeDataEnCours.step7IsDone">
          <div class="row">
            <div class="col-sm-12">
              <label for="isStationnementPresent">Souhaitez-vous occuper des places de stationnement situées sur le domaine public ?</label>
              <go-switch id="isStationnementPresent" class="pull-right" v-model="demandeDataEnCours.isStationnementPresent"></go-switch>
            </div>
          </div>
          <hr>

          <div class="row" v-if="demandeDataEnCours.isStationnementPresent">
            <div class="col-sm-6">
              <div class="form-group">
                <label for="StationnementNumMacarons" class="control-label">Nombre de places autorisées aux macarons </label>
                <input type="number" min=0 id="StationnementNumMacarons" v-model="demandeDataEnCours.StationnementNumMacarons">
              </div>
              <div id="divDateBeginStationnementNumMacarons" class="col-sm-6" v-show="demandeDataEnCours.StationnementNumMacarons > 0">
                <div class="form-group">
                  <label for="dateDebutOccupationStationnementNumMacarons" class="control-label">
                    Date de début :
                  </label>
                  <datepicker  id="dateDebutOccupationStationnementNumMacarons" v-model="demandeDataEnCours.StationnementNumMacarons_date_debut"
                               language="fr" :full-month-name="true" :bootstrapStyling="true" :mondayFirst="true"
                               v-on:selected="dateDebutUpdateStationnementNumMacarons"
                               :disabled="dateDebutDisabled_StationnementNumMacarons"
                               :highlighted="datePickerHighlighted_StationnementNumMacarons">
                  </datepicker>
                </div>
              </div>
              <div id="divDateEndStationnementNumMacarons" class="col-sm-6" v-show="demandeDataEnCours.StationnementNumMacarons > 0">
                <div class="form-group">
                  <label for="dateFinOccupationStationnementNumMacarons" class="control-label">
                    Date de fin :
                  </label>
                  <datepicker id="dateFinOccupationOccupationStationnementNumMacarons" v-model="demandeDataEnCours.StationnementNumMacarons_date_fin"
                              language="fr" :full-month-name="true" :bootstrapStyling="true" :mondayFirst="true"
                              v-on:selected="dateFinUpdateStationnementNumMacarons"
                              :disabled="dateFinDisabled_StationnementNumMacarons"
                              :highlighted="datePickerHighlighted_StationnementNumMacarons">
                  </datepicker>
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <label for="StationnementNumAutres" class="control-label">Nombre d'autres places</label>
                <input type="number" min=0 id="StationnementNumAutres"  v-model="demandeDataEnCours.StationnementNumAutres">
              </div>
              <div id="divDateBeginStationnementNumMacarons" class="col-sm-6" v-show="demandeDataEnCours.StationnementNumAutres >0">
                <div class="form-group">
                  <label for="dateDebutOccupationStationnementNumAutres" class="control-label">
                    Date de début :
                  </label>
                  <datepicker  id="dateDebutOccupationStationnementNumAutres" v-model="demandeDataEnCours.StationnementNumAutres_date_debut"
                               language="fr" :full-month-name="true" :bootstrapStyling="true" :mondayFirst="true"
                               v-on:selected="dateDebutUpdateStationnementNumAutres"
                               :disabled="dateDebutDisabled_StationnementNumAutres"
                               :highlighted="datePickerHighlighted_StationnementNumAutres">
                  </datepicker>
                </div>
              </div>
              <div id="divDateEndStationnementNumMacarons" class="col-sm-6" v-show="demandeDataEnCours.StationnementNumAutres >0">
                <div class="form-group">
                  <label for="dateFinOccupationOccupationStationnementNumAutres" class="control-label">
                    Date de fin :
                  </label>
                  <datepicker id="dateFinOccupationOccupationStationnementNumAutres" v-model="demandeDataEnCours.StationnementNumAutres_date_fin"
                              language="fr" :full-month-name="true" :bootstrapStyling="true" :mondayFirst="true"
                              v-on:selected="dateFinUpdateStationnementNumAutres"
                              :disabled="dateFinDisabled_StationnementNumAutres"
                              :highlighted="datePickerHighlighted_StationnementNumAutres">
                  </datepicker>
                </div>
              </div>
            </div>
            <div id="divStationnementCommentaire"class="form-group col-sm-12">
                <div class="">
                  <label for="StationnementCommentaire" class="control-label">Commentaire : </label>
                </div>
                <div class="">
                  <textarea rows="3" id="StationnementCommentaire" v-model="demandeDataEnCours.StationnementCommentaire" type="text" class="form-control"/>
                </div>
            </div>
          </div>
          <div class="col-sm-12" >
              <el-alert :closable="false" type="step7ValidationType" :title="step7ValidationText"></el-alert>
              <el-button  id="cmdstep7Save" type="primary" class="pull-right"
                        v-on:click="saveForm($event);demandeDataEnCours.step7IsDone=true;"
                        :disabled="!isStep7Valid">
               SUIVANT<i class="el-icon-arrow-right el-icon-right"></i>
             </el-button>
          </div>
        </go-collapse>
        <!-- FIN SECTION 6 : PLACES DE STATIONNEMENT -->
        <go-collapse :title="step8Msg" :open="demandeDataEnCours.step7IsDone && !demandeDataEnCours.step8IsDone"
                     :disabled="!isStep6Valid && !demandeDataEnCours.step7IsDone" :done="demandeDataEnCours.step8IsDone">
          <div class="alert alert-info" role="alert">
            <p>Le requérant demeure seul responsable envers la Commune de Lausanne du respect des
              <a href="http://www.lausanne.ch/lausanne-officielle/administration/finances-et-mobilite/routes-mobilite/domaine-public-utilisation-temporaire-du-domaine-public/domaine-public-conditions-d-usage-du-domaine-public.html"
              target="_blank">
                conditions d'usage du domaine public
              </a>
              ou d'un bien fonds qui lui est assimilé.
            </p>
            <p>
              En cochant la case ci-dessous, il certifie les avoir lues et accepte les suites pénales
              ou juridiques en cas d'accident.
              Le présent formulaire, les conditions d'usage du domaine public,
              ainsi que les tarifs en vigueur, peuvent être obtenus sur le présent site Internet:
              <a href="http://www.lausanne.ch/lausanne-officielle/administration/finances-et-mobilite/routes-mobilite/domaine-public-utilisation-temporaire-du-domaine-public.html"
              target="_blank">
                www.lausanne.ch/domaine_public</a>
            </p>
            <strong>Acceptez-vous les
              <a href="http://www.lausanne.ch/lausanne-officielle/administration/finances-et-mobilite/routes-mobilite/domaine-public-utilisation-temporaire-du-domaine-public/domaine-public-conditions-d-usage-du-domaine-public.html"
              target="_blank">
                conditions générales de l'utilisation temporaire du domaine public ?
              </a>
            </strong>

            <go-switch v-model="demandeDataEnCours.IsConditionGeneralAccepted"></go-switch>
            <br>

          </div>
          <div class="col-sm-12" >
              <el-alert :closable="false" type="step8ValidationType" :title="step8ValidationText"></el-alert>
              <el-button  id="cmdsendForm" type="primary" class="pull-right"
                        v-on:click="submitForm($event);demandeDataEnCours.step8IsDone=true;"
                        :disabled="!isFormValid">
               ENVOI DE LA DEMANDE<i class="el-icon-arrow-right el-icon-right"></i>
             </el-button>
          </div>
        </go-collapse>
      </div>

    </div><!-- FIN DE LA DIV  id="questions" v-show="isIdDemandeValid"> -->
    <div id="information" v-show="isIdDemandeValid && isSubmitToLocalDatabaseSuccessfull">

      <go-collapse :title="stepRequestSendedMsg" :open="isSubmitToLocalDatabaseSuccessfull"
                   :disabled="false" :done="isSubmitToLocalDatabaseSuccessfull">

      Madame, Monsieur,<br /><br />
      Votre demande de permis d'occupation temporaire du domaine public numéro {{demandeDataEnCours.id}}
      nous a été envoyée le {{demandeDataEnCours.datesubmited}} <br><br>
      Nous vous en remercions et vous informons que son traitement est en cours.<br>
      Une réponse de notre part vous parviendra, au plus tard, trois jours ouvrables avant la date d'occupation souhaitée.<br><br>

      Vous pouvez consulter les valeurs envoyées pour votre demande <a :href="getViewUrl()">ici</a><br /><br />

      Dans l'intervalle, nous vous adressons, Madame, Monsieur, nos cordiales salutations.<br /><br /><br />
      <small><b>Ville de Lausanne</b> | service des routes et de la mobilité | surveillance du domaine public</small><br />
      <small>rue du Vallon 27 | 1005 Lausanne | T +41 21 315 5412 ou 5472 ou 5262  |
        <a href='http://www.lausanne.ch/lausanne-officielle/administration/finances-et-mobilite/routes-mobilite/domaine-public-utilisation-temporaire-du-domaine-public.html'
        target="_blank">web</a></small>
      </go-collapse>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import vSelect from 'vue-select'
  import goCollapse from './ui/goCollapse'
  import goSwitch from './ui/goSwitch.vue'
  import {BASE_REST_API_URL, DEV, getLog} from './config'
  import {demandePoDP} from './demandePoDP'
  import goSelectActeur from './geo/goSelectActeur.vue'
  import {functionExist, isNullOrUndefined, getStringParam} from 'cgil-html-utils'
  import goCollapseActeurRoleDetails from './ui/goCollapseActeurRoleDetails.vue'
  import cgilOlMap from './cgil-vue-olmap/cgil-vue-olmap'
  import './cgil-vue-olmap/ol.css'
  import { hexToArr } from './cgil-vue-olmap/tools'
  import Datepicker from 'vuejs-datepicker'

  const log = getLog('goelandFormPODP', 4, 1)

  // const pos = [538127.1, 151624.1] // Av Acacacias Lausanne
  const pos = [2537874.0, 1152109.0] // gare lausanne
  // const pos = [538350.5, 152669.0] // cathedrale Lausanne
  const baseLayerSelected = getStringParam('baselayer', 'fonds_geo_osm_bdcad_gris')
  const layersVisibility = getStringParam('lvisibles', '41')
  const arrLayersVisibility = hexToArr(`0x${layersVisibility}`)
  log.w(`layersVisibility:${layersVisibility} => arrLayersVisibility: ${arrLayersVisibility}`)

export default {
    name: 'goelandFormPodp',
    components: {
      cgilOlMap,
      goSwitch,
      vSelect,
      goCollapse,
      goCollapseActeurRoleDetails,
      goSelectActeur,
      Datepicker
    },
    props: {
      guid: {
        type: String,
        default: null
      }
    },
    data: function () {
      return {
        isItDevEnv: DEV,
        center: pos,
        isGuidNull: null,
        data_json: null, // Ref sur le contenu de la demande distante initiale provenant de la db goeland
        // GESTION DES ETATS DE CHARGEMENTS
        isDemandeInitialeROLoaded: false, // chargement des donnees initiales distante data_json initiale est-il termine
        isIdDemandeValid: false,
        isDemandeAlreadysaved: null, // est-ce que la demande en cours contient deja des données ?
        isdemandeDataEnCoursLoaded: false, // est-ce que les données de la demande en cours sont chargées ?
        isSubmitToLocalDatabaseSuccessfull: false, // on a envoye le formulaire et il est sauve dans la BD  postgresql locale
        isGuidValid: null,
        // GESTION ERREUR SAUVEGARDE
        isSavingError: false,
        lastSavingError: '',
        goodStreetIds: [], // pour stocker ids des rues du chantier pour controle securite
        step1Msg: '1. identification',
        // une fois que l'utilisateur indique au moins une rue en relation avec cette demande
        // on considere cette etape 1 d'identification  comme terminee et on passe a la suivante
        step1IsDone: false,
        step2Msg: '2. informations générales',
        /* dans cette etape on affice les informations en lecture uniquement de la demande initiale
         on verifie dans la BD locale si un debut de demande existe si c'est le cas on rafraichi les donnee
         si ce ne'est pas le cas alors l'utilisateur doit :
                 a) [IsContactPoliceDone] : confirmer qu'il a pris contact avec la police
                 b) responsablePolice : indiquer le responsable police avec qui il a discuté
                 c) IsConditionGeneralAccepted: confirmer qu'il accepte les Conditions generales
            une fois que ces 3 conditions sont remplies l'Etape 2 est terminee [step2IsDone=true]
            on sauve l'etat de la demande en cours demandeDataEnCours
         */

        step2arrContactPolice: ['Anouk Louvet-Jardin', 'Frédéric Vauthey', 'Martial Maillard'],
        step3Msg: '3. interlocuteurs',
        step3arrActeurFacturationOptions: [
          'Bénéficiaire du permis',
          'Maitre d\'ouvrage',
          'Mandataire',
          'Autre'
        ],
        step4Msg: '3. localisation',
        step4ValidationType: 'info',
        showMap: false,
        isPolygonAlreadyPresentInGoeland: null,
        dateDebutDisabled: {to: null, from: null},
        dateFinDisabled: {to: null, from: null},
        datePickerHighlighted: {to: null, from: null},
        step5Msg: '4. fouilles',
        dateDebutDisabled_fouille: {to: null, from: null},
        dateFinDisabled_fouille: {to: null, from: null},
        datePickerHighlighted_fouille: {to: null, from: null},
        step5ValidationType: 'info',
        step6Msg: '5. occupation',
        step6ValidationType: 'info',
        step7Msg: '6. places de stationnement',
        step7ValidationType: 'info',
        // pour les controles datepicker min max
        dateDebutDisabled_StationnementNumMacarons: {to: null, from: null},
        dateFinDisabled_StationnementNumMacarons: {to: null, from: null},
        datePickerHighlighted_StationnementNumMacarons: {to: null, from: null},
        dateDebutDisabled_StationnementNumAutres: {to: null, from: null},
        dateFinDisabled_StationnementNumAutres: {to: null, from: null},
        datePickerHighlighted_StationnementNumAutres: {to: null, from: null},
        step8Msg: '7. envoi de la demande',
        step8ValidationType: 'info',
        stepRequestSendedMsg: 'Votre demande a été envoyée',
        idDemande: null, // pour permetre evt saisie manuellecacheInitialData id affaire (securite)
        streetSelected: null, // pour stocker rue selectionne par utilisateur (securite)
        streetName: '',
        streetList: [],
        geometrieChantiersSaisiePrecedement: '',
        // ############ informations initiales recues via Goeland sur cette demande
        demandeInitialeRO: {
          id: 0, // READONLY data_json["IdAffaire"]  identifiant externe de cette demande id affaire goeland
          nomAffaire: null, // NEW data_json["NomAffaire"] titre affaire goéland
          datecreated: null, // date de creation des donnees distante demande initiale
          responsableVdL: null, //  data_json["ResponsableVdL"] le user qui saisit la demande
          itWasUnAuthorizedOccupacy: null, // data_json["BRegularisation"] s'agit itl d'une regularisation
          BPayant: null, // data_json["BPayant"] le permis est payant
          // infos provenant de coordination chantier
          IdAffCoordChantier: null, // data_json["IdAffCoordChantier"]
          nomAffCoordChantier: null, // data_json["NomAffCoordChantier"]
          UOLeaderAffCoordChantier: null, // data_json["UOLeaderAffCoordChantier"]
          geomAffCoordChantier: null, // data_json["GeomAffCoordChantier"]
          // infos concernant les acteurs liés reçus data_json["ActeurL": [{...}]
          // on doit recevoir au moins 1 entree dans ActeurL
          isBeneficiaireGiven: false,
          isMandataireGiven: false,
          Beneficiaire: {
            idActeur: null,
            Role: null,
            Nom: null,
            AdresseCorresp: null,
            Telephone: null,
            TelephonePortable: null,
            Fax: null,
            Email: null
          },
          Mandataire: {
            idActeur: null,
            Role: null,
            Nom: null,
            AdresseCorresp: null,
            Telephone: null,
            TelephonePortable: null,
            Fax: null,
            Email: null
          },
          // cas du IdAffCoordChantier et UOLeaderAffCoordChantier non null du coup c'est eux le Maitre Ouvrage
          isMaitreOuvrageGiven: false,
          MaitreOuvrage: {
            Role: null,
            Nom: null
          }
        },
        // ############ informations saisie par le client concernant cette demande qui sera renvoyée plus loin

        demandeDataEnCours: {
          // **** infos identifiant la demande initiale
          id: null,   // READONLY data_json["IdAffaire"]  identifiant externe de cette demande id affaire goeland
          guid: null,  // READONLY  guid demande initiale passee dans url
          realGuid: null,  // READONLY dernier (temporellement) guid reel utilise pour la demande distante
          // **** infos geree par le systeme
          datecreated: null, // date premiere sauvegarde de cette demande cote client
          datelastmodif: null, // date derniere modification de cette demande cote client
          datesubmited: null,  // date de bouclement (submit final) de cette demande cote client
          // **** infos concernant Etape 2 de la demande cote client
          affClientContact: null, // data_json["AffClientContact"]
          affClientEmail: null, // data_json["AffClientEmail"]
          affClientTelephone: null, // data_json["AffClientTelephone"]
          IsContactPoliceDone: true,
          responsablePolice: '', // string
          IsConditionGeneralAccepted: false,
          step2IsDone: false,
          // **** infos concernant Etape 3 de la demande cote client
          acteurBeneficiaire: {
            isActeurFromGoeland: false,
            idActeurFromGoeland: null,
            isActeurValid: false,
            isActeurCollapsed: false,
            isActeurPhysique: false,
            IdActeurSelected: null,
            RaisonSociale: null,
            RaisonSocialeIsValid: false,
            RueNumero: null,
            CPVille: null,
            Telephone: null,
            TelephonePortable: null,
            Fax: null,
            Email: null
          },
          acteurMaitreOuvrage: {
            isActeurValid: false,
            isActeurCollapsed: false,
            isActeurPhysique: false,
            IdActeurSelected: null,
            RaisonSociale: null,
            RaisonSocialeIsValid: false,
            RueNumero: null,
            CPVille: null,
            Telephone: null,
            TelephonePortable: null,
            Fax: null,
            Email: null
          },
          acteurMandataire: {
            isActeurFromGoeland: false,
            idActeurFromGoeland: null,
            isActeurValid: false,
            isActeurCollapsed: false,
            isActeurPhysique: false,
            IdActeurSelected: null,
            RaisonSociale: null,
            RaisonSocialeIsValid: false,
            RueNumero: null,
            CPVille: null,
            Telephone: null,
            TelephonePortable: null,
            Fax: null,
            Email: null
          },
          isActeurFacturationOneOfPrevious: true,
          acteurFacturationOptionSelected: 'Bénéficiaire du permis', // TODO la valeur par defaut s'affiche pas
          acteurFacturation: {
            isActeurValid: false,
            isActeurCollapsed: false,
            isActeurPhysique: false,
            IdActeurSelected: null,
            RaisonSociale: null,
            RaisonSocialeIsValid: false,
            RueNumero: null,
            CPVille: null,
            Telephone: null,
            TelephonePortable: null,
            Fax: null,
            Email: null
          },
          step3IsDone: false,
          // **** infos concernant Etape 4 de la demande cote client
          // ici on rappelle les rues et les adresses concernées
          commentaireLocalisation: null, // Commentaire sur la localisation
          descriptionTravaux: null,  // [string] champ libre
          dateDebutOccupation: null, // [date] limiter date maintenant moins n mois
          dateFinOccupation: null,   // [date] doit etre plus grand que debut et minumum 10 jours
          //  En cas de prolongation du chantier, veuillez nous transmettre une copie du permis délivré avec l'indication des nouvelles dates, ceci avant son échéance.
          step4IsDone: false,
          geometrieChantiersSaisie: null, // saisie de la geometrie
          // ** Utilisation du domaine public pour une fouille
          isFouilleOuForage: false, // [Boolean] les travaux se situent-ils sur la chaussée ?
          // debut ajout champs pour demande DESMET juin 2023
          fouilleLongueur01: 0,    // [Number] Longueur fouille
          fouilleLargeur01: 0,    // [Number] Largeur fouille
          fouilleSurface01: 0,    // [Number] Surface fouille
          fouilleLongueur02: 0,
          fouilleLargeur02: 0,
          fouilleSurface02: 0,
          fouilleLongueur03: 0,
          fouilleLargeur03: 0,
          fouilleSurface03: 0,
          fouilleLongueur04: 0,
          fouilleLargeur04: 0,
          fouilleSurface04: 0,
          fouilleSurfaceTotal: 0,
          fouilleDateDebut: null,
          fouilleDateFin: null,
          // fin ajout champs pour demande DESMET juin 2023
          isFouilleSurChaussee: false, // [Boolean] les travaux se situent-ils sur la chaussée ?
          isFouilleSurTrotoir: false, // [Boolean] les travaux se situent-ils sur un trottoir ?
          isFouilleSurZonePavee: false,
          isFouilleSurZonePaveeDevisDemande: false,
          isFouilleEndomageBalisageSol: false, // [Boolean] les travaux endommageront-ils le balisage au sol ?
          step5IsDone: false,
          // ** Occupation du domaine public
          isOccupationDP: false,
          // debut ajout champs pour demande DESMET juin 2023
          occupationDPLongueur01: 0,
          occupationDPLargeur01: 0,
          occupationDPSurface01: 0,
          isOccupation_PoseDeposeModificationEnseigne: false,
          // fin ajout champs pour demande DESMET juin 2023
          isOccupation_Benne: false,
          isOccupation_DepotMateriel: false,
          isOccupation_DepotEnginsChantier: false,
          isOccupation_PalissadeOuClotureChantier: false, // palissade / clôture de chantier
          isOccupation_RoulotteOuContainer: false,  //       roulotte / container de chantier
          isOccupation_CamionNacelle: false,  //             camion nacelle
          isOccupation_CamionGrue: false,  //         camion grue
          isOccupation_Grue: false,  //               grue
          isOccupation_ChauffageMobile: false,  //    chauffage mobile
          isOccupation_Echafaudage: false,  //        échafaudage
          isOccupation_ElagageArbre: false,  //       élagage d'arbre
          isOccupation_Etayage: false,  //           étayage
          isOccupation_PontRoulant: false,  //        pont roulant
          isOccupation_GroupeElectrogene: false,  //        groupe électogène (ajout 2022)
          isOccupation_AccesChantier: false,  //      accès chantier
          isOccupation_Autre: false,  //      Autre
          Occupation_Autre: null,
          step6IsDone: false,
          isStationnementPresent: false,
          StationnementCommentaire: null, // [string] champ libre ajoute 04/12/2018 feedback Steve Michaud
          StationnementNumMacarons: 0,
          StationnementNumMacarons_date_debut: null,
          StationnementNumMacarons_date_fin: null,
          StationnementNumAutres: 0,
          StationnementNumAutres_date_debut: null,
          StationnementNumAutres_date_fin: null,
          step7IsDone: false,
          step8IsDone: false,
          isFinalSubmitDone: false  // c'est ici que l'on va garde l'info si l'envoi definitif est fait
        },
        mapLayers: {
          baseLayer: baseLayerSelected,
          layerForQueryInit: 'bdcad_bf_parc_pol,bdcad_bf_parc_pol_dp,bdcad_bf_parc_pol_ddp,bdcad_cs_bati_pol,bdcad_cs_bati_pol_sout,bdcad_bf_point',
          wmsLayers: [
            {
              layers: 'bdcad_projets_msgroup',
              title: 'Projets et chantiers',
              isVisible: arrLayersVisibility[0]
            },
            {
              layers: 'bdcad_pf_pfp_msgroup,bdcad_pf_pfp_alti',
              title: 'PFP',
              isVisible: arrLayersVisibility[1]
            },
            {
              layers: 'bdcad_pfp_reperage_msgroup',
              title: 'PFP repérage',
              isVisible: arrLayersVisibility[2]
            },
            {
              layers: 'bdcad_pf_pfa_msgroup,bdcad_pf_pfa_alti',
              title: 'PFA',
              isVisible: arrLayersVisibility[3]
            },
            { // je choisis la version du GC public pour que cela fonctionne partout
              layers: 'envconst_arbres_public_remarquables,envconst_arbres_public_remplacement,envconst_arbres_public_projet,envconst_arbres_public_abattage,envconst_arbres_public_autres',
              title: 'Arbres',
              isVisible: arrLayersVisibility[4]
            },
            {
              layers: 'envconst_toitures_veg',
              title: 'Toitures Végétalisées',
              isVisible: arrLayersVisibility[5]
            },
            /* // pas disponible sur map :
            {
              layers: 'bdcad_bf_parcom_pol',
              title: 'Parcelles Communales',
              isVisible: arrLayersVisibility[6],
            },
               */
            {
              layers: 'perimetres_lim_com_msgroup',
              title: 'Limites Communales',
              isVisible: arrLayersVisibility[6]
            },
            {
              layers: 'altimetrie_hauteur_vegetation_mnc_class',
              title: 'Canopée végétation',
              isVisible: arrLayersVisibility[7]
            }
          ]
        } // FIN DE LA CONFIG DES mapLayers
      }
    }, // end of data section
    computed: {
      isStep2Valid: function () {
        if (!this.isSubmitToLocalDatabaseSuccessfull) {
          if (this.isIdDemandeValid && this.demandeDataEnCours.IsContactPoliceDone) {
            // si les donnees ne proviennent pas deja de la BD locale alors on sauve
            if (!this.isDemandeAlreadysaved) {
              this.saveForm()  // fin du step2 premiere sauvegarde
            }
            return true
          } else {
            this.demandeDataEnCours.step2IsDone = false
            return false
          }
        }
      },
      isStep3Valid: function () {
        if (!this.isSubmitToLocalDatabaseSuccessfull) {
          /*
          if (this.demandeDataEnCours.acteurBeneficiaire.isActeurValid &&
            this.demandeDataEnCours.acteurMaitreOuvrage.isActeurValid) {
            this.demandeDataEnCours.step3IsDone = true
            if (this.isDemandeAlreadysaved) {
              this.saveForm()
            }
            return true
          } else {
            this.demandeDataEnCours.step3IsDone = false
            return false
          }
          */
          return true
        }
      },
      isStep4Valid: function () {
        if (!this.isSubmitToLocalDatabaseSuccessfull) {
          if (this.demandeDataEnCours.dateDebutOccupation !== null &&
            this.demandeDataEnCours.dateFinOccupation !== null &&
            this.demandeDataEnCours.descriptionTravaux !== null &&
            (this.demandeDataEnCours.geometrieChantiersSaisie !== null || this.isPolygonAlreadyPresentInGoeland)
          ) {
            this.saveForm()
            return true
          } else {
            this.demandeDataEnCours.step4IsDone = false
            return false
          }
        }
      },
      step4ValidationText: function () {
        let msg = ' Veuillez svp saisir'
        if (this.demandeDataEnCours.geometrieChantiersSaisie == null &&
            this.isPolygonAlreadyPresentInGoeland === false) msg += ' la géométrie du chantier,'
        if (this.demandeDataEnCours.descriptionTravaux == null) msg += ' la description,'
        if (this.demandeDataEnCours.dateDebutOccupation === null &&
            this.demandeDataEnCours.dateFinOccupation === null) {
          msg += ' les dates de début et fin d\'occupation.'
        } else {
          if (this.demandeDataEnCours.dateFinOccupation === null) msg += ' la date de fin d\'occupation.'
        }
        if (this.isStep4Valid) msg = 'Vous pouvez passer à l\'étape suivante en cliquant sur le bouton ci-contre'
        return msg
      },
      // 4. Fouilles sur DP
      isStep5Valid: function () {
        return true // en attendant d'avoir des infos de validation plus precise ...
      },
      step5ValidationText: function () {
        let msg = ''
        return msg
      },
      // Occupation du DP
      isStep6Valid: function () {
        if (this.demandeDataEnCours.isFouilleOuForage === false && this.demandeDataEnCours.isOccupationDP === false) {
          this.demandeDataEnCours.step6IsDone = false
          return false
        }
        if (this.demandeDataEnCours.isFouilleOuForage === true && this.demandeDataEnCours.isOccupationDP === false) {
          this.demandeDataEnCours.step6IsDone = false
          return false
        }
        if (this.demandeDataEnCours.isOccupationDP === true && !this.isOccupationDPValid) {
          this.demandeDataEnCours.step6IsDone = false
          return false
        }
        return true
      },
      isOccupationDPValid: function () {
        // au moins une case a coche
        return (
          this.demandeDataEnCours.isOccupation_Benne ||
          this.demandeDataEnCours.isOccupation_DepotMateriel ||
          this.demandeDataEnCours.isOccupation_DepotEnginsChantier ||
          this.demandeDataEnCours.isOccupation_PalissadeOuClotureChantier ||
          this.demandeDataEnCours.isOccupation_RoulotteOuContainer ||
          this.demandeDataEnCours.isOccupation_CamionNacelle ||
          this.demandeDataEnCours.isOccupation_CamionGrue ||
          this.demandeDataEnCours.isOccupation_Grue ||
          this.demandeDataEnCours.isOccupation_ChauffageMobile ||
          this.demandeDataEnCours.isOccupation_Echafaudage ||
          this.demandeDataEnCours.isOccupation_ElagageArbre ||
          this.demandeDataEnCours.isOccupation_Etayage ||
          this.demandeDataEnCours.isOccupation_PontRoulant ||
          this.demandeDataEnCours.isOccupation_GroupeElectrogene ||
          this.demandeDataEnCours.isOccupation_AccesChantier ||
          this.demandeDataEnCours.isOccupation_PoseDeposeModificationEnseigne ||
          this.isOccupationDPValidAutre
        )
      },
      isOccupationDPValidAutre: function () {
        if (isNullOrUndefined(this.demandeDataEnCours.Occupation_Autre)) {
          return false
        } else {
          if (this.demandeDataEnCours.Occupation_Autre.length < 2) return false
        }
        return true
      },
      step6ValidationText: function () {
        let msg = ''
        if (this.demandeDataEnCours.isFouilleOuForage === false && this.demandeDataEnCours.isOccupationDP === false) {
          msg = 'Vous ne pouvez répondre NON aux deux questions des sections 4 et 5 !'
        }
        return msg
      },
      // Utilisation de Places de Stationnement
      isStep7Valid: function () {
        if (this.demandeDataEnCours.isStationnementPresent === true) {
          if ((this.demandeDataEnCours.StationnementNumMacarons + this.demandeDataEnCours.StationnementNumAutres) < 1) {
            return false
          }
          if (this.demandeDataEnCours.StationnementNumMacarons > 0) {
            if (isNullOrUndefined(this.demandeDataEnCours.StationnementNumMacarons_date_debut) ||
          isNullOrUndefined(this.demandeDataEnCours.StationnementNumMacarons_date_fin)) {
              return false
            }
          }
          if (this.demandeDataEnCours.StationnementNumAutres > 0) {
            if (isNullOrUndefined(this.demandeDataEnCours.StationnementNumAutres_date_debut) ||
          isNullOrUndefined(this.demandeDataEnCours.StationnementNumAutres_date_fin)) {
              return false
            }
          }
        }
        return true // en attendant d'avoir des infos de validation plus precise ...
      },
      step7ValidationText: function () {
        let msg = ''
        return msg
      },
      isFormValid: function () {
        if (this.isStep2Valid && this.isStep3Valid &&
          this.isStep4Valid && this.isStep5Valid &&
          this.isStep6Valid && this.isStep7Valid && this.demandeDataEnCours.IsConditionGeneralAccepted) {
          return true
        } else {
          return false
        }
      },
      step8ValidationText: function () {
        let msg = ''

        return msg
      },
      calculSurface01: function () {
        this.demandeDataEnCours.fouilleSurface01 = 0
        if ((this.demandeDataEnCours.fouilleLongueur01 > 0) && (this.demandeDataEnCours.fouilleLargeur01 > 0)) {
          this.demandeDataEnCours.fouilleSurface01 = (this.demandeDataEnCours.fouilleLongueur01 * this.demandeDataEnCours.fouilleLargeur01).toFixed(2)
          return `${this.demandeDataEnCours.fouilleSurface01} m²`
        } else {
          return `${this.demandeDataEnCours.fouilleSurface01} m²`
        }
      },
      calculSurface02: function () {
        this.demandeDataEnCours.fouilleSurface02 = 0
        if ((this.demandeDataEnCours.fouilleLongueur02 > 0) && (this.demandeDataEnCours.fouilleLargeur02 > 0)) {
          this.demandeDataEnCours.fouilleSurface02 = (this.demandeDataEnCours.fouilleLongueur02 * this.demandeDataEnCours.fouilleLargeur02).toFixed(2)
          return `${this.demandeDataEnCours.fouilleSurface02} m²`
        } else {
          return `${this.demandeDataEnCours.fouilleSurface02} m²`
        }
      },
      calculSurface03: function () {
        this.demandeDataEnCours.fouilleSurface03 = 0
        if ((this.demandeDataEnCours.fouilleLongueur03 > 0) && (this.demandeDataEnCours.fouilleLargeur03 > 0)) {
          this.demandeDataEnCours.fouilleSurface03 = (this.demandeDataEnCours.fouilleLongueur03 * this.demandeDataEnCours.fouilleLargeur03).toFixed(2)
          return `${this.demandeDataEnCours.fouilleSurface03} m²`
        } else {
          return `${this.demandeDataEnCours.fouilleSurface03} m²`
        }
      },
      calculSurface04: function () {
        this.demandeDataEnCours.fouilleSurface04 = 0
        if ((this.demandeDataEnCours.fouilleLongueur04 > 0) && (this.demandeDataEnCours.fouilleLargeur04 > 0)) {
          this.demandeDataEnCours.fouilleSurface04 = (this.demandeDataEnCours.fouilleLongueur04 * this.demandeDataEnCours.fouilleLargeur04).toFixed(2)
          return `${this.demandeDataEnCours.fouilleSurface04} m²`
        } else {
          return `${this.demandeDataEnCours.fouilleSurface04} m²`
        }
      },
      calculSurfaceTotal: function () {
        this.demandeDataEnCours.fouilleSurfaceTotal = 0
        if ((this.demandeDataEnCours.fouilleSurface01 > 0) || (this.demandeDataEnCours.fouilleSurface02 > 0)) {
          this.demandeDataEnCours.fouilleSurfaceTotal =
            (parseFloat(this.demandeDataEnCours.fouilleSurface01) +
              parseFloat(this.demandeDataEnCours.fouilleSurface02) +
              parseFloat(this.demandeDataEnCours.fouilleSurface03) +
              parseFloat(this.demandeDataEnCours.fouilleSurface04)).toFixed(2)
          return `${this.demandeDataEnCours.fouilleSurfaceTotal} m²`
        } else {
          return `${this.demandeDataEnCours.fouilleSurface04} m²`
        }
      },
      calculSurfaceOccupationDP01: function () {
        this.demandeDataEnCours.occupationDPSurface01 = 0
        if ((this.demandeDataEnCours.occupationDPLongueur01 > 0) && (this.demandeDataEnCours.occupationDPLargeur01 > 0)) {
          this.demandeDataEnCours.occupationDPSurface01 = (this.demandeDataEnCours.occupationDPLongueur01 * this.demandeDataEnCours.occupationDPLargeur01).toFixed(2)
          return `${this.demandeDataEnCours.occupationDPSurface01} m²`
        } else {
          return `${this.demandeDataEnCours.occupationDPSurface01} m²`
        }
      }
    }, // end of computed props section

    watch: {
      '$route' (to, from) {
        log.w('## IN demandePoDP.watch($route) ', to, from)
        if (to.params.guid !== from.params.guid) {
          log.w(`#### NAVIGATE FROM : ${from.params.guid}`)
          log.w(`#### NAVIGATE TO   : ${to.params.guid}`)
          // TODO provide a global reinit of all forms vars to default
          this.isGuidNull = false
          this.isDemandeInitialeROLoaded = false
          this.step1IsDone = false
          this.isIdDemandeValid = false
          this.isGuidValid = false
          this.streetSelected = null
          if (!isNullOrUndefined(to.params.guid)) {
            demandePoDP.getDemandeInitiale(to.params.guid, (dataref) => {
              log.l('## IN demandePoDP.watch($route) callback for reloading of :' + to.params.guid)
              this.cacheInitialData(dataref)
            })
          } else {
            log.w('## IN demandePoDP.watch($route) to.params.guid is undefined !')
          }
        } else {
          log.w('## IN demandePoDP.watch($route) : NO NAVIGATION BECAUSE guid is the same')
          log.w(`#### NAVIGATE FROM : ${from.params.guid}`)
          log.w(`#### NAVIGATE TO   : ${to.params.guid}`)
        }
      },
      'demandeDataEnCours.IsContactPoliceDone' (val) {
        log.l('## IN demandePoDP.watch(demandeDataEnCours.IsContactPoliceDone)', val)
      }
    },
    created: function () {
      log.l('## INSIDE  goelandFormPodp created ')
      if (this.guid !== null) {
        this.isGuidNull = false
        demandePoDP.getDemandeInitiale(this.guid, (dataref) => {
          log.l('## INSIDE demandePoDP.getDemandeInitiale callback for created')
          this.cacheInitialData(dataref)
        })
      } else {
        log.w('## INSIDE  goelandFormPodp created : guid is null')
        this.isGuidNull = true
      }
    }, // end of created hook section

    mounted: function () {
      axios.get(`${BASE_REST_API_URL}/streets`)
      .then(resp => {
        // console.dir(resp)
        this.streetList = resp.data
      })
      .catch(err => {
        log.e('## ERROR IN Form mounted axios.get ', err)
      })
      log.l('## IN  goelandFormPodp mounted ')
      if (this.guid !== null) {
        if (demandePoDP.isDemandeCached(this.guid)) {
          this.cacheInitialData(demandePoDP.getDemandeInitiale(this.guid))
        }
      }
    }, // end of mounted hook section

    filters: {
      convertReturn2Comma: function (value) {
        if (!value) return ''
        value = value.toString()
        return value.replace('\n', ', ')
      }
    },
    methods: {
      cacheInitialData (dataref) {
        log.l('## IN  goelandFormPodp.cacheInitialData ')
        if (typeof dataref === 'object') {
          try {
            this.data_json = JSON.parse(dataref['json_data'])
            log.l('data_json is :', JSON.stringify(this.data_json, null, 2))
            this.demandeDataEnCours.guid = this.guid
            this.demandeDataEnCours.realGuid = dataref['guid']
            this.demandeInitialeRO.datecreated = dataref['datecreated']
            this.idDemande = this.data_json['IdAffaire']
            // lets's check if data was already saved
            demandePoDP.isDemandeAlreadysaved(this.idDemande, (data) => {
              log.l('## INSIDE demandePoDP.isDemandeAlreadysaved callback for done')
              this.isDemandeAlreadysaved = data // will be true or false
            })
            this.demandeInitialeRO.id = this.data_json['IdAffaire']
            this.demandeInitialeRO.nomAffaire = this.data_json['NomAffaire']
            this.demandeInitialeRO.responsableVdL = this.data_json['ResponsableVdL']
            this.demandeInitialeRO.itWasUnAuthorizedOccupacy = this.data_json['BRegularisation'] !== '0'
            this.demandeInitialeRO.BPayant = this.data_json['BPayant'] !== '0'
            // info du client a priori beneficiaire or acteur
            this.demandeDataEnCours.affClientContact = this.data_json['AffClientContact']
            this.demandeDataEnCours.affClientEmail = this.data_json['AffClientEmail']
            this.demandeDataEnCours.affClientTelephone = this.data_json['AffClientTelephone']
            // l'IDAFF "VDL-coordination chantier"
            this.demandeInitialeRO.IdAffCoordChantier = this.data_json['IdAffCoordChantier']
            this.demandeInitialeRO.nomAffCoordChantier = this.data_json['NomAffCoordChantier']
            this.demandeInitialeRO.UOLeaderAffCoordChantier = this.data_json['UOLeaderAffCoordChantier']
            if (this.demandeInitialeRO.IdAffCoordChantier) {
              // si on a un IdAffCoordChantier c'est que chantier vient de la Ville pas besoin de saisir MaitreOuvrage
              this.demandeInitialeRO.MaitreOuvrage.Role = 'Maitre d\'ouvrage'
              this.demandeInitialeRO.MaitreOuvrage.Nom = this.demandeInitialeRO.UOLeaderAffCoordChantier
              this.demandeInitialeRO.isMaitreOuvrageGiven = true
              this.demandeDataEnCours.acteurMaitreOuvrage.isActeurValid = true
            }
            let arrRue = this.data_json['RueL']
            if (isNullOrUndefined(arrRue)) {
              log.e('La liste des RueL est absente de la demande initiale')
              this.isDemandeInitialeROLoaded = false
              this.isGuidValid = false
            }
            for (let i = 0; i < arrRue.length; i++) {
              this.goodStreetIds.push(arrRue[i]['IdRueL'])
            }
            // traitement acteur liés "ActeurL": [{...}]
            // on doit recevoir au moins 1 entree dans ActeurL roles possibles sont beneficiaire et mandataire
            let arrActeurLie = this.data_json['ActeurL']
            if (arrActeurLie.length > 1) {
              this.demandeInitialeRO.isBeneficiaireGiven = true
              this.demandeInitialeRO.isMandataireGiven = true
              this.demandeDataEnCours.acteurMandataire.isActeurValid = true
              this.demandeDataEnCours.acteurBeneficiaire.isActeurValid = true
              // si on a deux entrees on part du principe que c'est mandataire qui a fait demande
              // et on recherche lequel des deux entrees il s'agit
              if (arrActeurLie[0]['Role'] === 'Maître d\'ouvrage') {
                this.demandeInitialeRO.Mandataire = arrActeurLie[0]
                this.demandeInitialeRO.Beneficiaire = arrActeurLie[1]
                this.demandeDataEnCours.acteurMandataire.isActeurFromGoeland = true
                this.demandeDataEnCours.acteurMandataire.idActeurFromGoeland = arrActeurLie[0]['IdActeur']
                this.demandeDataEnCours.acteurBeneficiaire.isActeurFromGoeland = true
                this.demandeDataEnCours.acteurBeneficiaire.idActeurFromGoeland = arrActeurLie[1]['IdActeur']
              } else {
                this.demandeInitialeRO.Beneficiaire = arrActeurLie[0]
                this.demandeInitialeRO.Mandataire = arrActeurLie[1]
                this.demandeDataEnCours.acteurMandataire.isActeurFromGoeland = true
                this.demandeDataEnCours.acteurMandataire.idActeurFromGoeland = arrActeurLie[1]['IdActeur']
                this.demandeDataEnCours.acteurBeneficiaire.isActeurFromGoeland = true
                this.demandeDataEnCours.acteurBeneficiaire.idActeurFromGoeland = arrActeurLie[0]['IdActeur']
              }
            } else { // on a qu'un seul acteur lié
              if (arrActeurLie[0]['Role'] === 'Requérant') {
                this.demandeInitialeRO.isBeneficiaireGiven = true
                this.demandeDataEnCours.acteurBeneficiaire.isActeurValid = true
                this.demandeInitialeRO.Beneficiaire = arrActeurLie[0]
                this.demandeDataEnCours.acteurBeneficiaire.isActeurFromGoeland = true
                this.demandeDataEnCours.acteurBeneficiaire.idActeurFromGoeland = arrActeurLie[0]['IdActeur']
              } else {
                this.demandeInitialeRO.isMandataireGiven = true
                this.demandeDataEnCours.acteurMandataire.isActeurValid = true
                this.demandeInitialeRO.Mandataire = arrActeurLie[0]
                this.demandeDataEnCours.acteurMandataire.isActeurFromGoeland = true
                this.demandeDataEnCours.acteurMandataire.idActeurFromGoeland = arrActeurLie[0]['IdActeur']
              }
            }
            log.l(`## IN  goelandFormPodp.cacheInitialData before isNullOrUndefined(this.demandeDataEnCours.geometrieChantiersSaisie)`,
              isNullOrUndefined(this.demandeDataEnCours.geometrieChantiersSaisie))
            if (isNullOrUndefined(this.demandeDataEnCours.geometrieChantiersSaisie)) {
              // on active la barre edition par defaut car pas de geometrie a priori
              this.isPolygonAlreadyPresentInGoeland = false
              log.l(`## IN  goelandFormPodp.cacheInitialData before !isNullOrUndefined(this.data_json['GeomAffCoordChantier'])`, this.data_json['GeomAffCoordChantier'])

              if (!isNullOrUndefined(this.data_json['GeomAffCoordChantier']['features'])) {
                let arrFeatures = this.data_json['GeomAffCoordChantier']['features']
                if (arrFeatures.length > 0) {
                  log.l(`## IN  goelandFormPodp.cacheInitialData found ${arrFeatures.length} features`, arrFeatures)
                  // on desactive la barre edition par defaut si la geometrie est fournie par coordination chantier
                  this.demandeInitialeRO.geomAffCoordChantier = arrFeatures[0].geometry
                  this.isPolygonAlreadyPresentInGoeland = true
                  // this.demandeDataEnCours.geometrieChantiersSaisie = arrFeatures[0].geometry
                }
              }
            }
            this.demandeDataEnCours.id = this.idDemande
            this.demandeDataEnCours.IdAffCoordChantier = this.demandeInitialeRO.IdAffCoordChantier
            this.demandeDataEnCours.datecreated = null
            // state management
            this.isDemandeInitialeROLoaded = true
            this.isGuidValid = true
          } catch (e) {
            log.e(`###  ERROR IN  goelandFormPodp.cacheInitialData while parsing json`, e, demandePoDP.lastError)
            this.demandeDataEnCours.realGuid = `## ERREUR ## pendant la lecture de la demande initiale en JSON: `
            this.demandeDataEnCours.realGuid += JSON.stringify(dataref)
            this.isDemandeInitialeROLoaded = false
            this.isGuidValid = false
          }
        } else {
          log.e(`###  ERROR IN  goelandFormPodp.cacheInitialData [${dataref}]`)
          log.e(`###  ERROR IN  goelandFormPodp.cacheInitialData : demandePoDP.lastError =`, demandePoDP.lastError)
          if (JSON.stringify(demandePoDP.lastError).indexOf('no records found') > 0) {
            this.demandeDataEnCours.realGuid = `## ERREUR ##  Aucune demande en cours avec pour cet identifiant !`
          } else {
            this.demandeDataEnCours.realGuid = `## ERREUR ##  [${JSON.stringify(demandePoDP.lastErrorMsg)}] !`
          }
          log.w(JSON.stringify(demandePoDP.lastError))
          log.e(demandePoDP.lastError)
          this.isDemandeInitialeROLoaded = false
          this.isGuidValid = false
        }
      }, // end of cacheInitialData
      // cette methode sert a sauver temporairement les donnes du formulaire
      saveForm (event) {
        if (this.isdemandeDataEnCoursLoaded || !this.isDemandeAlreadysaved) {
          log.l(`### IN  goelandFormPodp.saveForm `)
          if (this.isGuidValid) {
            let savedData = {
              id: this.idDemande,
              demandeDataEnCours: this.demandeDataEnCours
            }
            if (event) {
              if (functionExist(event.preventDefault)) event.preventDefault()
            }
            demandePoDP.saveDemande(this.demandeDataEnCours.realGuid, savedData, resp => {
              log.l('### IN  goelandFormPodp.saveForm AFTER saveDemande : ', resp)
              if (JSON.stringify(resp).indexOf('ERROR') > 0) {
                log.e('### ERROR IN  goelandFormPodp.saveForm AFTER saveDemande : ', resp)
                log.w('demandePoDP.lastError = ', demandePoDP.lastError)
                this.lastSavingError = `## ERREUR PENDANT LA SAUVEGARDE ! ## ${demandePoDP.lastErrorMsg} [${resp}] !`
                this.isSavingError = true
              } else {
                this.lastSavingError = ''
                this.isSavingError = false
              }
            })
          } else {
            this.lastSavingError = `## IMPOSSIBLE DE SAUVER ce guid est invalide : ${this.demandeDataEnCours.realGuid}] !`
            this.isSavingError = true
          }
        } else {
          log.w(`### IN  goelandFormPodp.saveForm NOT SAVING car isdemandeDataEnCoursLoaded est FAUX`)
        }
      },
      submitForm (event) {
        if (this.isdemandeDataEnCoursLoaded || !this.isDemandeAlreadysaved) {
          log.l(`### IN  goelandFormPodp.submitForm `)
          if (this.isGuidValid) {
            this.demandeDataEnCours.isFinalSubmitDone = true
            let savedData = {
              id: this.idDemande,
              demandeDataEnCours: this.demandeDataEnCours
            }
            if (event) {
              if (functionExist(event.preventDefault)) event.preventDefault()
            }
            demandePoDP.submitDemande(this.demandeDataEnCours.realGuid, savedData, resp => {
              log.l('### IN  goelandFormPodp.submitForm AFTER submitDemande : ', resp)
              if (JSON.stringify(resp).indexOf('ERROR') > 0) {
                log.e('### ERROR IN  goelandFormPodp.submitForm AFTER submitDemande : ', resp)
                log.w('demandePoDP.lastError = ', demandePoDP.lastError)
                this.lastSavingError = `## ERREUR PENDANT L'ENVOI DU FORMULAIRE ! ## ${demandePoDP.lastErrorMsg} [${resp}] !`
                this.isSavingError = true
              } else {
                this.lastSavingError = ''
                this.isSavingError = false
                this.isSubmitToLocalDatabaseSuccessfull = true
                // pour indiquer correctement la date dans la confirmation vu que l'on a pas le retour de la bd mais que c'est sauve
                let todayDate = new Date()
                this.demandeDataEnCours.datesubmited = todayDate.toLocaleString('fr')
              }
            })
          } else {
            this.lastSavingError = `## IMPOSSIBLE D'ENVOYER CE FORMULAIRE ce guid est invalide : ${this.demandeDataEnCours.realGuid}] !`
            this.isSavingError = true
          }
        } else {
          log.w(`### IN  goelandFormPodp.submitForm NOT SAVING car isdemandeDataEnCoursLoaded est FAUX`)
        }
      },
      dateDebutUpdate (val) {
        this.dateFinDisabled.to = val
        this.datePickerHighlighted.to = val
      },
      dateFinUpdate (val) {
        this.dateDebutDisabled.from = val
        this.datePickerHighlighted.from = val
      },
      dateDebutUpdateFouille (val) {
        this.dateFinDisabled_fouille.to = val
        this.datePickerHighlighted_fouille.to = val
      },
      dateFinUpdateFouille (val) {
        this.dateDebutDisabled_fouille.from = val
        this.datePickerHighlighted_fouille.from = val
      },
      dateDebutUpdateStationnementNumMacarons (val) {
        this.dateFinDisabled_StationnementNumMacarons.to = val
        this.datePickerHighlighted_StationnementNumMacarons.to = val
      },
      dateFinUpdateStationnementNumMacarons (val) {
        this.dateDebutDisabled_StationnementNumMacarons.from = val
        this.datePickerHighlighted_StationnementNumMacarons.from = val
      },
      dateDebutUpdateStationnementNumAutres (val) {
        this.dateFinDisabled_StationnementNumAutres.to = val
        this.datePickerHighlighted_StationnementNumAutres.to = val
      },
      dateFinUpdateStationnementNumAutres (val) {
        this.dateDebutDisabled_StationnementNumAutres.from = val
        this.datePickerHighlighted_StationnementNumAutres.from = val
      },
      newStreetSelected (val) {
        log.l('## in goelandFormPodp.newStreetSelected :', val)
        if (isNullOrUndefined(val)) {
          this.step1IsDone = false
          this.isIdDemandeValid = false
        } else {
          if (this.checkIsValidStreetId(val.value)) {
            this.step1IsDone = true
            this.isIdDemandeValid = true
            this.streetName = val.label
            // let that = this
            // a timer seems to be the only way to get it working
            window.setTimeout(function () {
              // that.$refs.mapchantier.updateScreen()
            }, 1500)

            if (this.isDemandeAlreadysaved) {
              // let's get back the current data
              demandePoDP.getdemandeEnCours(this.idDemande, (dataref) => {
                log.l('##****** IN demandePoDP.getdemandeEnCours callback', dataref)
                if (typeof dataref === 'string') {
                  log.e('## ERROR IN demandePoDP.getdemandeEnCours callback', dataref)
                  this.isdemandeDataEnCoursLoaded = false
                } else {
                  this.demandeDataEnCours = JSON.parse(dataref['json_data'])
                  this.demandeDataEnCours.datecreated = dataref['datecreated']
                  this.demandeDataEnCours.datelastmodif = dataref['datelastmodif']
                  this.demandeDataEnCours.datesubmited = dataref['datesubmited']
                  this.geometrieChantiersSaisiePrecedement = this.demandeDataEnCours.geometrieChantiersSaisie
                  if (!isNullOrUndefined(this.demandeDataEnCours.datesubmited)) {
                    this.isSubmitToLocalDatabaseSuccessfull = true
                  } else {
                    // this.$refs.mapchantier.updateScreen()
                  }
                  this.isdemandeDataEnCoursLoaded = true
                }
              })
            }
          } else {
            this.step1IsDone = false
            this.isIdDemandeValid = false
          }
        }
        // this.streetSelected = val.value
      },
      checkIsValidStreetId (idStreet) {
        if (((this.goodStreetIds.indexOf(idStreet)) > -1) &&
          this.demandeInitialeRO.id === this.idDemande) {
          log.l('##++ in goelandFormPodp.checkIsValidStreetId VALID idStreet:', idStreet)
          return true
        } else {
          log.l('##-- in goelandFormPodp.checkIsValidStreetId INVALID idStreet:', idStreet)
          return false
        }
      },
      saveGeometry: function (val) {
        log.l('##++ in goelandFormPodp.saveGeometry cgil-vue-olmap event gomapSaveGeomClick received : ', val)
        this.demandeDataEnCours.geometrieChantiersSaisie = val
      },
      adjustMap: function (val) {
        log.l('##++ in goelandFormPodp.adjustMap goCollapse event gocollapseOpen received : ', val)
        this.showMap = true
        // 2018-05-03 cgil commented out next line because it breaks map display component when collapse is false and reveals underlying content
        // this.$refs.mapchantier.updateScreen()
      },
      getViewUrl: function () {
        return `/#/view/${this.demandeDataEnCours.realGuid}`
      }
    } // end of methods section
  }
</script>


<style lang="scss">

  .fouille-legend{
    font-size: 16px;
    margin-bottom: 4px;
  }
  .fouille-fieldset{
    padding-top: 5px;
    padding-bottom: 5px;
  }

  .goOccupationCheckbox{
    font-size: 1em;
  }

  .cg-button-next{
    padding-top: 15px;
  }

  /*
    $current_field_color: #1512e9;

    $base_size: 32px;
    * {
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
      box-sizing: border-box;
    }

    /* default design for small device first */
  /*
    form {
      padding: ($base_size / 6);
      width: 100%;
      fieldset {
        width: 100%;
        text-align: left;
        div {
          margin-top: ($base_size / 6);
          input, select, textarea {
            width: 100%;
            font-size: 1em;
            &:focus {
              outline: 0;
              border-color: $current_field_color;
            }
          }
        }
      }
    }

    @media (min-width: 600px) {
      form {
        background-color: #5bc0de;
        font-size: 1.1em;
        fieldset {
          div {
            label {
              width: 40%;
              float: left;
              padding-right: 1em;
            }
            input, select, textarea {
              width: 60%;
              font-size: 1.2em;
            }
          }
        }
      }
    }

    @media (min-width: 1024px) {
      .form-container {
        width: 100%;
        padding: 1.2em 2em 1em 2em;
      }
      form {
        background-color: #c4e3f3;
        font-size: 1.1em;
        fieldset {
          div {
            display: inline-flex;
            width: 50%;
            float: left;
            label {
              text-align: right;
              width: 45%;
            }
            input, select, textarea{
              width: 55%;
            }



          }
        }
      }
    }
  */
</style>



// WEBPACK FOOTER //
// src/components/goelandFormPodp.vue